module.exports = __webpack_public_path__ + "img/75.8.TSS.f138f4b3.png";